export enum StatusCodeType {
    Aborted = -1,
    NetworkError = 0,
    Ok = 200,
    BadRequest = 400,
    Unauthorized = 401,
    PaymentRequired = 402,
    Forbidden = 403,
    ClientClosedRequest = 499,
    /*
    ADConfigurationNotFound = 650,
    ADSidClaimNotFound = 651,
    ADUserMandatoryInformationMissed = 652,
*/
}
